"use client"

import { useState, useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate, Navigate } from "react-router-dom"
import { Row, Col, FormGroup, Input, Button, Label, Modal, ModalHeader, ModalBody, Card, CardBody } from "reactstrap"
import Services from "./services.js"
import AuthService from "../Authentication/auth.service.js"
import LoadingOverlay from "react-loading-overlay-ts"
import DNALoader from "../../components/Loaders/DnaLoader.js"
import Alerts from "../../components/Alerts/alerts.js"
import PermissionAccess from "../../PermissionAccess/Access.js"

const UpdateDoctor = ({ doctor, onSuccess, onCancel }) => {
  const [modal, setModal] = useState(true)
  const [Doctor, setDoctor] = useState({
    ...doctor,
    clinic_name: doctor.clinic_name || "",
    apc_number: doctor.apc_number || "",
    Phone: doctor.phone || doctor.Phone || "",
  })
  const [loading, setLoading] = useState(false)
  const [loginNavigate, setLoginNavigate] = useState(false)
  const { authData } = PermissionAccess()
  const navigate = useNavigate()
  const { t, i18n } = useTranslation()

  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem("language"))
  }, [i18n])

  const handleDoctorChange = (field, value) => {
    setDoctor((prev) => ({ ...prev, [field]: value }))
  }

  const validateForm = () => {
    return (
      Doctor.name &&
      Doctor.RegistrationNumber &&
      Doctor.email &&
      Doctor.Phone &&
      Doctor.clinic_name &&
      Doctor.apc_number &&
      Doctor.Address
    )
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!validateForm()) {
      Alerts.swalErrorAlert("Please fill all fields.")
      return
    }

    const payload = {
      ...Doctor,
      // business_id: Doctor.business_id,
      // user_type_id: Doctor.user_type_id || "6576b4b4e66749ea4ce13108",
      // user_type: Doctor.user_type || "doctors",
      // all_required_have: Doctor.all_required_have || "false",
      // status: Doctor.status || "pending",
    }

    setLoading(true)
    try {
      const response = await Services.Update_Doctor(authData.sessionID, payload)
      setLoading(false)
      if (response.data.status) {
        onSuccess()
        Alerts.swalSuccessAlert(response.data.message || "Doctor Updated Successfully.").then(() => {
          setModal(false)
        })
      } else {
        if (response.data.message === "Unauthorized") {
          AuthService.logout()
          setLoginNavigate(true)
        } else {
          Alerts.swalErrorAlert(
            response.data.message || "Error: Can't Update Doctor at the moment. Please try again later.",
          )
        }
      }
    } catch (error) {
      setLoading(false)
      Alerts.swalErrorAlert("Network Operation failed.")
    }
  }

  if (loginNavigate) {
    return <Navigate to={"/login"} />
  }

  return (
    <Modal size="lg" isOpen={modal} toggle={() => setModal(false)} backdrop={true}>
      <LoadingOverlay active={loading} spinner={<DNALoader />}>
        <ModalHeader>{t("Update Doctor")}</ModalHeader>
        <ModalBody>
          <Card className="main-card mb-3">
            <CardBody>
              <form onSubmit={handleSubmit}>
                <FormGroup className="mb-3">
                  <Row>
                    <Col md="6">
                      <Label>{t("Doctor Name")}</Label>
                      <Input
                        type="text"
                        value={Doctor.name}
                        onChange={(e) => handleDoctorChange("name", e.target.value)}
                        placeholder={t("Enter Doctor Name")}
                      />
                    </Col>
                    <Col md="6">
                      <Label>{t("Registration Number")}</Label>
                      <Input
                        type="text"
                        value={Doctor.RegistrationNumber}
                        onChange={(e) => handleDoctorChange("RegistrationNumber", e.target.value)}
                        placeholder={t("Enter Registration Number")}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Label>{t("Email")}</Label>
                      <Input
                        type="email"
                        value={Doctor.email}
                        onChange={(e) => handleDoctorChange("email", e.target.value)}
                        placeholder={t("Enter Email")}
                      />
                    </Col>
                    <Col md="6">
                      <Label>{t("Phone")}</Label>
                      <Input
                        type="tel"
                        value={Doctor.Phone}
                        onChange={(e) => handleDoctorChange("Phone", e.target.value)}
                        placeholder={t("Enter Phone Number")}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Label>{t("Clinic Name")}</Label>
                      <Input
                        type="text"
                        value={Doctor.clinic_name}
                        onChange={(e) => handleDoctorChange("clinic_name", e.target.value)}
                        placeholder={t("Enter Clinic Name")}
                      />
                    </Col>
                    <Col md="6">
                      <Label>{t("APC Number")}</Label>
                      <Input
                        type="number"
                        value={Doctor.apc_number}
                        onChange={(e) => handleDoctorChange("apc_number", e.target.value)}
                        placeholder={t("Enter APC Number")}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <Label>{t("Address (Google Location)")}</Label>
                      <Input
                        type="text"
                        value={Doctor.Address}
                        onChange={(e) => handleDoctorChange("Address", e.target.value)}
                        placeholder={t("Enter Address")}
                      />
                    </Col>
                  </Row>
                  <div className="text-center mt-3">
                    <Button type="submit" color="success" size="lg" className="me-3">
                      {t("Update")}
                    </Button>
                    <Button
                      type="button"
                      color="secondary"
                      size="lg"
                      onClick={() => {
                        setModal(false)
                        onCancel()
                      }}
                    >
                      {t("Cancel")}
                    </Button>
                  </div>
                </FormGroup>
              </form>
            </CardBody>
          </Card>
        </ModalBody>
      </LoadingOverlay>
    </Modal>
  )
}

export default UpdateDoctor

